"use strict";

import {
  fixedDepositsConstants,
  commonConstants,
  responseCodes,
} from "../_constants";

const getInitialState = () => ({
  fixedDepositList: [],
  fixedDepositRateList: [],
  fixedDepositEligibleCasaList: [],
  selectedEligibleCasaAccount: {},
  selectedEligibleInterestPayableAccount: {},
  fixedDepositEligibleInterestPayableAccountList: [],
  isFixedDepositsListLoading: false,
  fixedDepositProductType: "",
  fixedDepositPayableMethod: "",
  fixedDepositsPeriod: "",
  fixedDepositAutomaticRenewal: "",
  fixedDepositPrincipalAmount: "",
  fixedDepositMaturityAmount: "",
  fixedDepositInterestAmount: "",
  minimumPrincipalAmount: "",
  maximumPrincipalAmount: "",
  fixedDepositProductCode: "",
  fixedDepositProductDescription: "",
  initiateData: {},
  otpConfrimationData: {},
  otpConfirmationFailed: false,
  otpConfirmResponseCode: "",
  otpConfirmResponseMessage: "",
  fdReceiptDetails: {},
  fdOtpTimer: 0,
});

export function fixedDeposits(state = getInitialState(), action) {
  switch (action.type) {
    case fixedDepositsConstants.FIXED_DEPOSITS_LIST_REQUEST:
      return {
        ...state,
        isFixedDepositsListLoading: true,
        fixedDepositList: [],
      };
    case fixedDepositsConstants.FIXED_DEPOSITS_LIST_COMPLETE:
      return {
        ...state,
        isFixedDepositsListLoading: false,
        fixedDepositList: action.payload.data?.accountDetails,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_LIST_ERROR:
      return {
        ...state,
        isFixedDepositsListLoading: false,
        fixedDepositList: [],
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_REQUEST:
    case fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        fixedDepositProductCode: "",
        fixedDepositProductDescription: "",
      };
    case fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_COMPLETE:
      return {
        ...state,
        fixedDepositProductCode: action.payload.data?.productCode,
        fixedDepositProductDescription:
          action.payload.data?.productCodeDescription,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_REQUEST:
      return {
        ...state,
        initiateData: {},
        fdOtpTimer: 0,
      };
    case fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_COMPLETE:
      return {
        ...state,
        initiateData: action.payload.data,
        fdOtpTimer: action.payload.data?.otpTimerTimePeriod,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_ERROR:
      return {
        ...state,
        initiateData: {},
        otpConfirmResponseCode:
          action.payload.response?.statusCode ===
          responseCodes.SERVICE_ERROR_CODE
            ? responseCodes.FIXED_DEPOSIT_OPENING_FAILED
            : action.payload.response?.statusCode,
        otpConfirmResponseMessage: action.payload.response?.message,
        otpConfirmationFailed:
          action.payload.response?.statusCode ===
            responseCodes.SERVICE_ERROR_CODE && true,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSIT_PRODUCT_TYPE:
      return {
        ...state,
        fixedDepositProductType: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSIT_PRODUCT_CODE:
      return {
        ...state,
        fixedDepositProductCode: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSIT_PAYABLE_METHOD:
      return {
        ...state,
        fixedDepositPayableMethod: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSIT_PERIOD:
      return {
        ...state,
        fixedDepositsPeriod: action.payload,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_REQUEST:
    case fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_ERROR:
      return {
        ...state,
        fixedDepositRateList: [],
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_COMPLETE:
      return {
        ...state,
        fixedDepositRateList: action.payload.data?.interestList,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_REQUEST:
      return {
        ...state,
        fixedDepositEligibleCasaList: [],
        fixedDepositEligibleInterestPayableAccountList: [],
      };
    case fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_COMPLETE:
      return {
        ...state,
        fixedDepositEligibleCasaList: action.payload.data?.eligibleAccountList,
        fixedDepositEligibleInterestPayableAccountList:
          action.payload?.data?.eligibleInterestPaybaleAccountList || [],
        minimumPrincipalAmount:
          action.payload.data?.configuration?.minimumPrincipalAmount,
        maximumPrincipalAmount:
          action.payload.data?.configuration?.maximumPrincipalAmount,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_ERROR:
      return {
        ...state,
        fixedDepositEligibleCasaList: [],
        fixedDepositEligibleInterestPayableAccountList: [],
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSITS_ELIGIBLE_CASA_ACCOUNT:
      return {
        ...state,
        selectedEligibleCasaAccount: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSITS_ELIGIBLE_INTEREST_PAYABLE_CASA_ACCOUNT:
      return {
        ...state,
        selectedEligibleInterestPayableAccount: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSITS_AUTOMATIC_RENEWAL:
      return {
        ...state,
        fixedDepositAutomaticRenewal: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSITS_PRINCIPAL_AMOUNT:
      return {
        ...state,
        fixedDepositPrincipalAmount: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSITS_MATURITY_AMOUNT:
      return {
        ...state,
        fixedDepositMaturityAmount: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSITS_INTEREST_AMOUNT:
      return {
        ...state,
        fixedDepositInterestAmount: action.payload,
      };

    case fixedDepositsConstants.SET_FIXED_DEPOSIT_OPEN_INITIATE:
      return {
        ...state,
        initiateData: {},
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_COMPLETE:
      return {
        ...state,
        otpConfrimationData: action.payload.data,
        otpConfirmResponseCode: action.payload.data?.responseCode,
        otpConfirmResponseMessage: action.payload.data?.message,
        fdOtpTimer: 0,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_ERROR:
      return {
        ...state,
        otpConfirmResponseCode:
          action.payload.response?.statusCode ===
          responseCodes.SERVICE_ERROR_CODE
            ? responseCodes.FIXED_DEPOSIT_OPENING_FAILED
            : action.payload.response?.statusCode,
        otpConfirmResponseMessage: action.payload.response?.message,
        otpConfirmationFailed:
          action.payload.response?.statusCode ===
            responseCodes.SERVICE_ERROR_CODE && true,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_COMPLETE:
      return {
        ...state,
        otpConfrimationData: action.payload.data,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_ERROR:
      return {
        ...state,
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_REQUEST:
    case fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_ERROR:
    case fixedDepositsConstants.CLEAR_FIXED_DEPOSITS_RECEIPT:
      return {
        ...state,
        fdReceiptDetails: {},
      };

    case fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_COMPLETE:
      return {
        ...state,
        fdReceiptDetails: action.payload.data?.receiptDetails,
      };

    case fixedDepositsConstants.CLEAR_FIXED_DEPOSITS:
      return getInitialState();
  }
  return state;
}
